import { css, useTheme } from "@emotion/react";

import Box from "./Box.jsx";
import parseStyle from "./parseStyle.js";
import useThemeProps from "./useThemeProps.jsx";

export default function ContactCard(props) {
  const theme = useTheme();
  props = useThemeProps({ props, name: "ContactCard" });
  let { media, children, style, ...restProps } = props;
  return (
    <Box
      css={css`
        display: flex;
        gap: 1rem;
        &:not(:last-child) {
          margin-bottom: 12px;
        }
        ${parseStyle(style, theme)}
      `}
      {...restProps}
    >
      {media ? (
        <div
          css={css`
            align-self: flex-start;
            max-width: ${theme.getLength(30)};
            width: 20%;
          `}
        >
          {media}
        </div>
      ) : null}
      <div
        css={css`
          flex-grow: 1;
          flex-shrink: 1;
          align-self: center;
          display: flex;
          flex-direction: column;
        `}
      >
        {children}
      </div>
    </Box>
  );
}
